import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Product } from '../../../../models/product.model';
import { Order } from '../../../../models/order.model';
import { OrderItem } from '../../../../models/order-item.model';
import { ProductService } from '../../../../services/product.service';
import { OrderItemService } from '../../../../services/order-item.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';
import { MobileCheckServiceService } from '../../../../services/mobile-check-service.service';
import { ShippingMethod } from '../../../../enums/shipping-method';

@UntilDestroy()
@Component({
  selector: 'app-product-order-item-header',
  templateUrl: 'product-order-item-header.component.html',
  styleUrls: ['./product-order-item-header.component.scss'],
  standalone: false,
})
export class ProductOrderItemHeaderComponent {
  @Input() order: Order;

  @Input() orderItem: OrderItem;

  @Input() viewType: string;

  @Input() groupQuantity = -1;

  @Input() readonly = false;

  @Input() modal = false;

  @Input() showHideItemButton = false;

  @Input() showReorderButton = false;

  @Output() editted = new EventEmitter<void>();

  @Output() changedVisibility = new EventEmitter<boolean>();

  @Output() reorderItem = new EventEmitter();

  updatingFavorites = false;
  fetchingProduct = false;

  constructor(
    private productService: ProductService,
    private orderItemService: OrderItemService,
    private router: Router,
    private authService: AuthService,
    private mobileCheck: MobileCheckServiceService
  ) {}

  canBuyProduct(product: Product): boolean {
    const orderItem = this.order.findOrderItemByProduct(product);
    if (orderItem) {
      return true;
    }

    if (product.inventoryType) {
      return product.inStock;
    }

    return true;
  }

  toggleItemVisibility(): void {
    this.changedVisibility.emit(!this.orderItem.hidden);
  }

  showProduct(product: Product): void {
    this.fetchingProduct = true;
    this.productService
      .getProductRedirectUrl(product.id)
      .pipe(untilDestroyed(this))
      .subscribe((url) => {
        if (url) {
          this.router.navigateByUrl(url);
        }
        this.fetchingProduct = false;
      });
  }

  showProductDetails(): any {
    if (this.showReorderButton) {
      // for reorder show product on modal
      this.reorderItem.emit();
    } else {
      this.router.navigate([this.product.productURL]);
    }
    return false;
  }

  get showProductPrice(): boolean {
    return !this.discontinued && !this.product.hasVariations;
  }

  get showMinOrder(): boolean {
    if (this.readonly || this.discontinued) {
      return false;
    }

    if (!this.product.window_id) {
      return false;
    }

    if (!this.product.hasVariations) {
      return true;
    }

    return this.product.getGroupMinQuantity() > 0;
  }

  get showInStock(): boolean {
    return !this.readonly;
  }

  get product(): Product {
    return this.orderItem.product;
  }

  get canShowVendor(): boolean {
    return (
      this.viewType !== 'grid-item' &&
      this.viewType !== 'detailed' &&
      this.modal !== true
    );
  }

  get canShowFavorite(): boolean {
    return this.viewType === 'grid-item' && this.authService.canSeeFavorites;
  }

  get canShowShipmentTiming(): boolean {
    return ![ShippingMethod.NextDay, ShippingMethod.TwoDay].includes(
      this.orderItem.deliveries[0].method
    );
  }

  get hasFavorites(): boolean {
    return this.product && this.product.isFavorite;
  }

  get classes(): string {
    return `${this.viewType} ${this.orderItem.hidden === false ? 'line-separator--light-grey' : ''}`;
  }

  get mobile(): boolean {
    return this.mobileCheck.mobile;
  }

  get mobileDevice(): boolean {
    return this.mobileCheck.mobileDevice;
  }

  get productLink(): string {
    if (this.showReorderButton) {
    }

    return this.product.productURL;
  }

  get isProductRecommended(): boolean {
    return (
      !this.readonly &&
      !this.discontinued &&
      this.orderItemService.isProductRecommended(this.product, this.order)
    );
  }

  get discontinued(): boolean {
    if (!this.product.obsolete) {
      return false;
    }
    return !this.readonly && !this.orderItem.id;
  }
}
